import {
  Avatar,
  Box,
  Flex,
  Text
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { COLORS } from 'utils/styles'

export const QuoteMessage = ({
  quoted,
  quotedAuthor
}) => {
  const goToQuotedMsg = () => {
    if (!quoted?.eventId) return

    const el = document.getElementById(`msg-${quoted.eventId}`)
    if (!el) return

    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })

    // brief highlight so the user sees which message it is
    el.animate(
      [
        { backgroundColor: COLORS.darkGray },
        { backgroundColor: 'transparent' }
      ],
      { duration: 1500, easing: 'ease-out' }
    )
  }

  return (
    <Box
      position="relative"
      mb={2}
      pl={3}
      pr={2}
      py={1.5}
      bg="blackAlpha.300"
      borderRadius="3px"
      overflow="hidden"
      cursor={quoted ? 'pointer' : 'default'}
      onClick={() => goToQuotedMsg()}
      _hover={quoted ? { bg: COLORS.charcoalGray } : undefined}
      transition="background 0.3s"
      _before={{
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '3px',
        bg: COLORS.gold
      }}
    >
      <Flex alignItems="center">
        <Avatar
          src={quotedAuthor?.avatarUrl ?? ImagesPng.ProfileImage}
          width="15px"
          height="15px"
        />

        <Text
          fontSize="13px"
          paddingLeft="5px"
          fontWeight={600}
          color={COLORS.gold}
          noOfLines={1}
        >
          {quoted ? (quotedAuthor?.name ?? 'Unknown') : 'Original message'}
        </Text>
      </Flex>

      <Text
        fontSize="14px"
        lineHeight="1.3"
        color={COLORS.gray_op8}
        fontStyle={quoted ? 'normal' : 'italic'}
        noOfLines={2}
        wordBreak="break-word"
      >
        {quoted ? quoted.body : 'Not available'}
      </Text>
    </Box>
  )
}
